import styled, { css } from 'styled-components'

import { _M_Normal, mainColors, riskChannelsColors } from '@avantstay/backoffice-core'

export const IMG_SIZE = '48px'

export const OptionsList = styled.ul`
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 0;
  margin: 0;
  overflow: auto;
  list-style-type: none;
`

export const OptionsListItem = styled.li<{ $isSelected?: boolean }>`
  width: 100%;
  display: grid;
  grid-template-columns: ${IMG_SIZE} 1fr;
  align-items: center;
  gap: 8px;
  border: 2px solid;
  border-color: ${({ $isSelected }) =>
    $isSelected ? mainColors.accentLight : mainColors.neutralLight};
  border-radius: 4px;
  padding: 8px;
  cursor: pointer;
`

const imgStyles = () => css`
  width: ${IMG_SIZE};
  height: ${IMG_SIZE};
  border-radius: 50%;
`

export const HotelImg = styled.img`
  ${imgStyles};

  object-fit: contain;
`

export const HotelFallbackImg = styled.div`
  ${imgStyles};

  background: linear-gradient(
      ${riskChannelsColors.channelMobile},
      ${riskChannelsColors.channelWebsite}
    )
    border-box;
`

export const HotelDetails = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`

export const EmptyResults = styled.span`
  ${_M_Normal};

  display: flex;
  justify-content: center;
  color: ${mainColors.neutralExtraDark};
`
